<template>
  <BsModal :value="!firstVisitNotificationSeen">
    <template #title>
      <IxRes>frs.firstVisitModal.title</IxRes>
    </template>
    <IxRes>frs.firstVisitModal.notificationText</IxRes>
    <IxButton
      slot="footer" large
      submit @click="setModalSeenFlag"
    />
  </BsModal>
</template>

<script>
import {mapUiFlags} from '@frs/helpers/ui'

import BsModal from '@components/bootstrap/BsModal'

import IxButton from '@components/IxButton'

export default {
  components: {
    BsModal,
    IxButton
  },
  data () {
    return {
      showModal: true
    }
  },
  computed: {
    ...mapUiFlags([
      'frs.firstVisitNotificationSeen'
    ])
  },
  methods: {
    setModalSeenFlag () {
      this.firstVisitNotificationSeen = true
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
